module.exports = __webpack_public_path__ + "static/media/product-8.cce86090.jpg";